import * as actionTypes from '../../snackBarActionTypes';
import { AppThunk, SnackBarMessage } from '@greenkub-fronts/shared/interface';

export const removeSnackMessage =
  (msgId: number): AppThunk =>
  (dispatch, getState) => {
    const messages = getState().snackbar.messages.filter(
      (msg: SnackBarMessage) => msg.id !== msgId
    );

    dispatch({
      type: actionTypes.REMOVE_SNACK_MESSAGE,
      payload: {
        messages,
      },
    });
  };
